import React from 'react';
import { motion } from 'framer-motion';

const LegalPage = ({ title, content }) => {
  return (
    <div style={{ backgroundColor: '#f4e9dc', minHeight: '100vh', paddingTop: '140px', paddingBottom: '80px', color: '#2b1f18' }}>
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        style={{ maxWidth: '800px', margin: 'auto', padding: '0 20px', lineHeight: '1.8' }}
      >
        <h1 style={{ fontSize: '2.5rem', marginBottom: '40px', borderBottom: '2px solid #d1b892', paddingBottom: '10px' }}>
          {title}
        </h1>
        <div style={{ whiteSpace: 'pre-wrap', fontSize: '1.05rem', color: '#444' }}>
          {content}
        </div>
      </motion.div>
    </div>
  );
};

export default LegalPage;